import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Entrar } from '@/features/portal/entrar'
import { destinoDeVolta, voltaSearch } from '@/lib/volta'

/**
 * Entrada de quem é atendido, por código de uso único no e-mail.
 *
 * Fica fora da camada `_portal` para não exigir sessão de quem veio abrir
 * uma. A tela em si não sabe para onde vai depois: quem decide é a rota, que
 * volta para onde a sessão caiu quando veio de um `?volta=`. Sem volta, vai
 * para a raiz, que separa pelo papel: a terapeuta também pode entrar por
 * aqui, e `/portal` não tem nada para ela.
 */
export const Route = createFileRoute('/portal/entrar')({
  validateSearch: voltaSearch,
  component: function EntrarNoPortal() {
    const navigate = useNavigate()
    const { volta } = Route.useSearch()
    return (
      <Entrar
        aoEntrar={() =>
          navigate({ href: volta === undefined ? '/' : destinoDeVolta(volta, '/portal') })
        }
      />
    )
  },
})
